import { Injectable } from '@angular/core';
import { BaseService } from '.';
import { FuelReceipt } from '@cl/shared/models/fuel-reports/fuel-receipt.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class FuelReceiptsService extends BaseService<FuelReceipt> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/fuel-receipts/');
    }
}
